// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"46de4dc3","161":"c702faf7","369":"80aceba8","496":"7192089a","513":"6953a962","578":"bdf9299b","703":"475d10d5","802":"d737eb07","921":"dc7334cd"}[chunkId] + ".chunk.js";
};